import React from "react";

import styles from "./Social.module.scss";

import backgroundSrc from "../images/background-05.jpg";
import backgroundSrcRet from "../images/background-05@2x.jpg";
import backgroundWebp from "../images/background-05.webp";
import backgroundWebpRet from "../images/background-05@2x.webp";
import backgroundMobile from "../images/mobile/background-05.webp";

import Donuts from "./Donuts";
import TitleBloc from "./Elements/TitleBloc";

export default function Social() {
    return (
        <section className={styles.Main}>
            <div className={styles.GraphSection}>
                <div className="container">
                    <div className={styles.ChartsText}>
                        <h3>
                            Le nouveau visage <br/>
                            <strong>des gamers</strong>
                        </h3>
                        <p>
                            Selon l’étude d’Accenture, le stéréotype du jeune homme qui représente la majorité des joueurs de jeux vidéo est désormais erroné. En raison de l'adoption généralisée du mobile notamment, il y a aujourd’hui presqu’autant de joueuses (46%) que de joueurs (52%), et 2% de personnes s’identifiant au genre « non binaire » ou de non-répondants.
                        </p>
                    </div>

                    <Donuts/>
                </div>
            </div>

            <div className="container">

                <div className={styles.MastheadText}>
                    <p>
                        En France notamment, on chiffrait à 10% le nombre de joueuses en 1999. Du chemin a été parcouru
                        depuis, puisqu’en 2020, elles sont 47% à jouer régulièrement et sont âgées en moyenne de 39 ans,
                        selon une étude publiée fin 2020 par le Syndicat des Editeurs de Logiciels de Loisirs (SELL).
                        Autre indicateur, la part des femmes dans les formations dédiées au jeu vidéo est passée de 15 %
                        en 2017 à 27 % en 2021. Parmi les nouveaux arrivants, 60% sont des femmes, 30% ont moins de 25
                        ans et un tiers d’entre eux se définissent comme « non-blancs ».
                    </p>

                    <p>
                        Ces nouveaux gamers apprécient les jeux mobiles, mais aussi les rencontres ! Par ailleurs, 32%
                        des joueurs français ont affirmé jouer davantage qu’avant les confinements et 52% des joueurs
                        estiment que leur pratique permet « de créer du lien social ». Une majorité de personnes sondées
                        ont également confié jouer aux jeux pour rester en contact avec leurs amis, s’en faire de
                        nouveaux ou trouver une communauté qui leur correspond.
                    </p>

                    <p>
                        Alors que l’année 2020 a été marquée par les confinements et la distanciation sociale, le succès
                        d'un jeu vidéo semble en effet plus que jamais lié à sa capacité de créer du lien, puisque de
                        nombreux jeux permettent désormais de mettre en relation des personnes partageant les mêmes
                        centres d’intérêt. Le confinement a d’ailleurs été l’âge d’or pour « Among Us », jeu vidéo
                        d'ambiance multijoueur en ligne développé et édité par le studio InnerSloth, sorti en 2018 sur
                        Android, iOS, Chrome OS puis Windows, en 2020 sur Nintendo Switch et en 2021 sur PlayStation 4
                        et PlayStation 5. Pendant les périodes de confinement, Fortnite, qui rencontrait déjà un succès
                        fulgurant, a également permis de recréer du lien social. Rien qu’en avril, le « battle royale »
                        d’Epic Games a enregistré 3,2 milliards d’heures de jeu…
                    </p>
                </div>
            </div>

            <TitleBloc number={5} image={{
                src: backgroundSrc,
                srcRet: backgroundSrcRet,
                webp: backgroundWebp,
                webpRet: backgroundWebpRet,
                mobile: backgroundMobile
            }}>
                <h2>
                    Les limites du jeu ?
                </h2>

                <p>
                    PS5, Xbox Series, Switch… Tout comme l’industrie automobile ou les rayons électroménager, les consoles de jeux sont elles aussi touchées par la pénurie de composants électroniques qui dure depuis la sortie des hardwares à la fin de l’année 2020. Par manque de puces, les fabricants éprouvent en effet des difficultés à livrer leurs produits aux joueurs qui souhaitent se procurer une console next-gen. C’est le cas de Sony notamment qui peine à proposer avec régularité et certitude sa Playstation 5, très appréciée et recherchée. De son côté, Nintendo a dû revoir ses plans pour sa Switch Pro, qui permettrait de jouer à des jeux en résolution 4k contre 720p pour la Switch actuellement, par manque de substrat de type ABF. Elle était, au départ, attendue entre septembre et décembre 2021, mais ce scénario semble de plus en plus incertain. Elle pourrait finalement sortir plutôt en 2022.
                </p>
            </TitleBloc>
        </section>
    )
}
